// extracted by mini-css-extract-plugin
export default {"cell":"Rows_cell__QioiK"};